import React from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import LastMinuteInviteManager from '../components/LastMinuteInviteManager';
import LastMinuteSpotViewer from '../components/LastMinuteSpotViewer';
import './TournamentLastMinuteInvites.css';

const TournamentLastMinuteInvites = () => {
  const { tournamentId } = useParams();
  const { tournament } = useOutletContext();

  if (!tournament) {
    return (
      <div className="last-minute-invites-page loading">
        <div className="loading-spinner"></div>
        <p>Loading tournament information...</p>
      </div>
    );
  }

  return (
    <div className="last-minute-invites-page">
      <div className="page-header">
        <div className="header-content">
          <h1>🕐 Last-Minute Invites</h1>
          <p>Manage last-minute tournament spots for <strong>{tournament.name}</strong></p>
        </div>
        
        <div className="tournament-info">
          <span className="tournament-date">
            📅 {new Date(tournament.date).toLocaleDateString()}
          </span>
          <span className="tournament-time">
            🕐 {tournament.startTime}
          </span>
          <span className="tournament-status">
            📊 {tournament.status}
          </span>
        </div>
      </div>

      <div className="page-content">
        <div className="invites-grid">
          {/* Tournament Director Management Section */}
          <div className="management-section">
            <div className="section-header">
              <h2>🔧 Tournament Director Management</h2>
              <p>Create available spots and manage member reservations</p>
            </div>
            
            <LastMinuteInviteManager
              tournamentId={tournamentId}
              tournamentName={tournament.name}
            />
          </div>

          {/* Member View Section */}
          <div className="member-section">
            <div className="section-header">
              <h2>👤 Member View Preview</h2>
              <p>This is what members see when they receive invite emails</p>
            </div>
            
            <div className="member-preview-wrapper">
              <LastMinuteSpotViewer
                tournamentId={tournamentId}
                isPublic={false}
              />
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="invite-stats-summary">
          <h3>📊 Last-Minute Invite Statistics</h3>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">📍</div>
              <div className="stat-content">
                <span className="stat-number">0</span>
                <span className="stat-label">Available Spots</span>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon">⏳</div>
              <div className="stat-content">
                <span className="stat-number">0</span>
                <span className="stat-label">Pending Reservations</span>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-content">
                <span className="stat-number">2</span>
                <span className="stat-label">Opted-In Members</span>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon">📧</div>
              <div className="stat-content">
                <span className="stat-number">0</span>
                <span className="stat-label">Invites Sent</span>
              </div>
            </div>
          </div>
        </div>

        {/* Workflow Guide */}
        <div className="workflow-guide">
          <h3>🎯 Last-Minute Invite Workflow</h3>
          <div className="workflow-steps">
            <div className="workflow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Identify Empty Spots</h4>
                <p>Look at your tee sheet and identify positions that need to be filled</p>
              </div>
            </div>
            
            <div className="workflow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Create Available Spots</h4>
                <p>Use the form above to specify which spots are available for last-minute invites</p>
              </div>
            </div>
            
            <div className="workflow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Send Invite Emails</h4>
                <p>Click "📧 Create & Send Invites" to notify opted-in members</p>
              </div>
            </div>
            
            <div className="workflow-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h4>Manage Reservations</h4>
                <p>Review member requests and place them on the tee sheet</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentLastMinuteInvites;
